module.exports = __webpack_public_path__ + "img/gestao2.e2b0d829.png";